import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { CustomTableComponent } from "../../../shared/ui/custom-table/components/table/custom-table.component";


import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { BankAccountListV2Component } from "./components/bank-account-list/bank-account-list.components";
import { BankAccountReducer } from "./store/reducers/bank-account.reducer";
import { BankAccountService } from "./services/bank-account.service";
import { BankAccountEffects } from "./store/effects/bank-account.effects";
import { BankAccountFormDialogComponent } from "./components/bank-account-form-dialog/bank-account-form-dialog.component";
import { BankAccountDetailComponent } from "./components/bank-account-detail/bank-account-detail.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations:[
    BankAccountListV2Component,
    BankAccountFormDialogComponent,
    BankAccountDetailComponent,
  ],
  exports:[
    BankAccountListV2Component
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    RouterModule,
    FormsModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,

    // NgRx
    StoreModule.forFeature('bankAccountV2', BankAccountReducer),
    EffectsModule.forFeature([BankAccountEffects])
  ],
  providers: [
    BankAccountService
  ]
})

export class BankAccountModule { }
